document.addEventListener('DOMContentLoaded', function () {
	const newProfileSection = document.querySelector('.add-new-social-profile');
	if(newProfileSection){
		const addSocialBtn = document.querySelector('.add-social');
		const addNewBtn = newProfileSection.querySelector('.add-new-social');
		const closeAddBtn = newProfileSection.querySelector('.close-add-social');
		const fieldset = document.querySelector('.form-element-social-profile');
		const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/i;
	
		// Show "Add New" section
		addSocialBtn.addEventListener('click', function () {
			newProfileSection.classList.remove('d-none');
		});
		
		closeAddBtn.addEventListener('click', function () {
			newProfileSection.classList.add('d-none');
		});
		addNewBtn.addEventListener('click', function () {
			const typeSelect = newProfileSection.querySelector('#social-profile-type');
			const linkInput = newProfileSection.querySelector('#social-link');
			const selectedType = typeSelect.value;
			const enteredLink = linkInput.value.trim();

			linkInput.classList.remove('is-invalid');
			const existingError = linkInput.parentElement.querySelector('.input-error');
			if (existingError) existingError.remove();

			if (!enteredLink || !urlPattern.test(enteredLink)) {
				linkInput.classList.add('is-invalid');
				alert('Please enter a valid URL (e.g., https://example.com)');
				linkInput.focus();
				return;
			}

			const newItem = document.createElement('div');
			newItem.className = 'social-profile-item d-flex justify-content-between';
			newItem.innerHTML = `
			<div class="form-element">
				<label for="${selectedType.toLowerCase()}">${selectedType}</label>
				<input type="url" id="${selectedType.toLowerCase()}" name="${selectedType.toLowerCase()}" value="${enteredLink}" />
			</div>
			<button type="button" class="delete-file">
				<span class="icon-delete"></span>
			</button>
			`;

			fieldset.insertBefore(newItem, newProfileSection);

			linkInput.value = '';
			typeSelect.selectedIndex = 0;
			newProfileSection.classList.add('d-none');
		});
		
		fieldset.addEventListener('click', function (e) {
			if (e.target.closest('.delete-file')) {
				const item = e.target.closest('.social-profile-item');
				if (item) {
					const socialCount = item.getAttribute('data-social');
					console.log(socialCount);
					item.remove();
				}
			}
		});

	}
}); 